var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analytics"},[_c('GuestsBoardAnalytics'),_c('span',{staticClass:"pb-16 d-block"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }